<template>
  <v-card>
    <!-- <ClientAssocDialog ref="assocDialog" /> -->

    <SimCardDetailsDialog ref="simDetailsDialog" />

    <v-card-text class="">
      <ORow top nowrap>
        <OCapCont label="P/I">
          <OTagList :value="status"/>
        </OCapCont>

        <OCapCont label="Firmware">
          <tt>0x{{ client.fwVersion | hex }}</tt>
        </OCapCont>

        <BasePicker
          label="Lote"
          :value="client.batchNumber"
          icon="mdi-pencil"
          :clearable="false"
          @open="changeBatchNumber"/>

        <!-- <OCapCont label="Lote">
          <span class="flex-grow-1">{{ client.batchNumber }}</span>
          <v-btn icon @click="changeBatchNumber">
            <v-icon>edit</v-icon>
          </v-btn>
        </OCapCont> -->

        <BasePicker
          style="min-width: 300px"
          label="SIM Card"
          :value="operatorName + ' ─ ' + iccid"
          icon="mdi-sim-outline"
          @open="showSimDetails"
          :clearable="false"
          />



        <OCapCont label="Estoque atual">
          {{ currentDepotName }}
        </OCapCont>
      </ORow>
    </v-card-text>

    <!-- <v-row class="ma-0"> -->
    <!-- <v-col cols="6">
          <label class="light-caption">Pausado?</label>
          <v-btn :color="pausedColor" @click="changePaused">{{
            pausedLabel
          }}</v-btn>
        </v-col>
        <v-col cols="6">
          <label class="light-caption">Ignorado?</label>
          <v-btn :color="ignoredColor" @click="changeIgnored">{{
            ignoredLabel
          }}</v-btn>
        </v-col> -->

    <!-- <v-col cols="12">
          <label class="light-caption">Organização</label>
          <p class="big-content d-flex align-center">
            <router-link
              :to="`/orgs/${client.organizationId}`"
              class="flex-grow-1"
            >
              {{ client.organization.label }}
            </router-link>
            <v-btn icon class="flex-grow-0" @click="startAssoc()">
              <v-icon>mdi-camera-switch</v-icon>
            </v-btn>
          </p>
        </v-col> -->
    <!-- </v-row> -->

    <!-- <v-divider />

    <v-card-text class="pa-0">
      <v-row class="ma-0">
        <v-col cols="12" class="cap-cont">
          <label>Firmware</label>
          <p>
            <tt>0x{{ client.fwVersion | hex }}</tt>
          </p>
        </v-col>
        <v-col cols="12" class="cap-cont">
          <label>Lote</label>
          <p class="d-flex align-center">
            <span class="flex-grow-1">{{ client.batchNumber }}</span>
            <v-btn icon @click="changeBatchNumber">
              <v-icon>edit</v-icon>
            </v-btn>
          </p>
        </v-col> -->
    <!-- <v-col cols="12" class="cap-cont">
          <label>Ponteiro (Receiver)</label>
          <p class="d-flex align-center">
            <tt class="flex-grow-1">0x{{ client.lastPointer | hex }}</tt>
            <v-btn icon @click="changeRecvPointer">
              <v-icon>edit</v-icon>
            </v-btn>
          </p>
        </v-col> -->
    <!-- <v-col cols="12" class="cap-cont">
          <label>SIM Card</label>
          <p class="d-flex align-start">
            <span style="min-width: 0" class="flex-grow-1 d-inline-block">
              <tt class="d-block text-truncate">{{ iccid }}</tt>
              <span>{{ operatorName }}</span>
            </span>
            <v-btn icon class="flex-grow-0" @click="showSimDetails">
              <v-icon>edit</v-icon>
            </v-btn>
          </p>
        </v-col>
        <v-col cols="12" class="cap-cont">
          <label>Estoque atual</label>
          <p>{{ currentDepotName }}</p>
        </v-col>
      </v-row>
    </v-card-text> -->
  </v-card>
</template>

<script>
import _ from 'lodash'
import { SimCard, Client } from '@/models'
import { isEmpty } from 'oderon-commons/src/utils'
import BasePicker from 'oderon-vue/cpts/pickers/BasePicker.vue'
import SimCardDetailsDialog from '../../setup/sim-cards/DetailsDialog.vue'
import OTagList from 'oderon-vue/cpts/OTagList.vue'

export default {
  props: {
    client: { required: true }
  },
  components: {
    SimCardDetailsDialog,
    BasePicker,
    OTagList
  },
  computed: {
    status() {
      let result = []
      if ( this.client.isPaused ) result.push('Pausado')
      if ( this.client.isIgnored ) result.push('Ignorado')
      if ( result.length == 0 ) result.push('OK')
      return result
    },
    iccid() {
      return _.get(this.client, 'simCard.iccid', '─')
    },
    currentDepotName() {
      return _.get(this.client, 'currentDepot.name', '─')
    },
    operatorName() {
      return _.get(this.client, 'simCard.operator', '?')
    },
    hasTrouble() {
      let t = _.get(this.client, 'hasTrouble')
      return t ? 'SIM' : 'NÃO'
    }
  },
  methods: {
    async patch(what) {
      await this.$loading(() => Client.patch(this.client.id, what))
      this.$emit('reload')
    },

    async changeBatchNumber() {
      let newV = await this.$prompt({
        label: 'Digite o lote deste módulo',
        value: this.client.batchNumber
      })

      if (!isEmpty(newV)) this.patch({ batchNumber: newV })
    },

    async changeRecvPointer() {
      let value = this.client.lastPointer || 0

      let newV = await this.$prompt({
        label: 'Digite o ponteiro a partir do qual o Receiver irá pedir dados',
        value,
        decHex: true
      })

      if (!isEmpty(newV)) this.patch({ lastPointer: +newV })
    },

    async showSimDetails() {
      let dialog = this.$refs.simDetailsDialog,
        res = await dialog.open(this.client.simCardId)

      if (res == 'RELOAD') this.$emit('reload')
      // {
      //   this.$loading(async () => {
      //     await SimCard.save(res)
      //     await Store.reload()
      //     this.$snack('Salvo com sucesso')
      //   })
      // }
    }
  }
}
</script>

<style></style>
